<template>
  <div class="skeleton"
       :class="[{'active':active},'line-'+line]">
    <div class="right">
      <div class="title"></div>
      <p class="line"
         v-for="(item, index) in line"
         :key="index"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'skeleton-search',
  props: {
    active: {
      type: Boolean,
      default: true
    },
    line: {
      type: [String, Number],
      default: 3
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.skeleton {
  min-height: 150px;
  display: flex;
  background-color: #fff;
  &.active .avatar,
  &.active .title,
  &.active .line {
    background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
    animation: skeleton-loading 1.4s ease infinite;
    background-size: 400% 100%;
  }
  .right {
    padding: 0 11px;
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    .title,
    .line {
      width: 100%;
      height: 20px;
      margin-bottom: 10px;
      background-color: #f2f2f2;
      &:first-child {
        height: 210px;
        width: 100%;
        border-radius: 8px;
      }
      &:nth-child(2) {
        height: 22px;
        width: 288px;
      }
       &:nth-child(3) {
        height: 22px;
        width: 337px;
      }
    }
    .title {
      width: 40%;
      margin-bottom: 20px;
    }
  }
  &.line-2 {
    min-height: 100px;
    .right {
      .line {
        width: 80%;
      }
      .title {
        width: 60%;
      }
    }
  }
}
</style>
